var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitelogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#23dbdb;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "White SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M571.7,137q13.38,0,21.93-8.15t8.56-20.87q0-11.91-9.05-20.63a30.72,30.72,0,0,0-42.88,0q-9,8.73-9,20.63,0,12.72,8.56,20.87T571.7,137Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1023.3,228.19A85.78,85.78,0,0,0,958,219.34a24.5,24.5,0,0,1,3.47,13,24,24,0,0,1-6.94,17.28,22.88,22.88,0,0,1-33.25,0,25.63,25.63,0,0,1-4.12-5.6,85.23,85.23,0,0,0-22.71,58c0,1.11,0,2.22.08,3.32Q913.83,317,937.94,317q35.38,0,60.42-24.78t25-60C1023.38,230.83,1023.35,229.51,1023.3,228.19Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.37,293.31c-11.11,4.48-22.38,7.47-31.45,7.47-14,0-19.55-11.07-19.55-24,0-30.24,20.28-59.75,40.94-80.4.37,3.32.37,10.33,5.16,10.33,4.43,0,9.22-7,11.44-10,17.33-26.19,62-56.8,94.42-56.8,7.82,0,12.69,6.13,14,13.19a118.19,118.19,0,0,1,31.9-6.74c-1.55-8.64-5-15.32-10.51-19.73-7.38-5.53-18.45-7.38-33.2-3.32l-.37-.37a110.7,110.7,0,0,1,16.23-8.11c5.53-1.85,18.07-5.17,18.07-12.91,0-5.9-18.44-32.09-35.77-29.51-71.19,10-194,100.32-189.58,180,3.32,57.17,36.51,74.87,65.65,75.24a113.06,113.06,0,0,0,16.81-1.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M505.35,313.69h-61V226q0-10.11-2.12-14c-1.42-2.61-4-3.91-7.67-3.91q-10.26,0-10.27,18.09v87.56h-61V226q0-10.11-2.2-14c-1.46-2.61-4.05-3.91-7.74-3.91q-10.11,0-10.11,18.09v87.56h-61V213.58q0-27.39,18.43-46.55t44.67-19.16q27.06,0,48.59,22.83,24-22.83,47.93-22.83,30.49,0,48.91,22.18,14.52,17.28,14.52,50.38Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M727.08,149.5v65.22q-6.36-3.58-11.57-3.59-16.63,0-16.63,25.44v77.12h-61V224.83q0-35.22,19.24-56.17t51.36-20.95A125.6,125.6,0,0,1,727.08,149.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M834.2,149.5v65.22q-6.36-3.58-11.57-3.59-16.64,0-16.63,25.44v77.12H745V224.83q0-35.22,19.24-56.17t51.36-20.95A125.6,125.6,0,0,1,834.2,149.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1138,149.5v65.22q-6.36-3.58-11.58-3.59-16.62,0-16.63,25.44v77.12h-61V224.83q0-35.22,19.23-56.17t51.36-20.95A125.6,125.6,0,0,1,1138,149.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 541.05,
    y: 151.13,
    width: 60.98,
    height: 162.55
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M917.12,244a24.38,24.38,0,0,1-2.81-11.68A24,24,0,0,1,921.15,215a23.23,23.23,0,0,1,33.43,0,24.13,24.13,0,0,1,3.38,4.37,85.78,85.78,0,0,1,65.34,8.85Q1022,196,998.67,172.57,974,147.72,939.42,147.71q-36.87,0-62,24.37t-25.1,60.08q0,35.07,25.1,59.92a89,89,0,0,0,17,13.31c-.06-1.1-.08-2.21-.08-3.32A85.23,85.23,0,0,1,917.12,244Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.7,247.9c-11.08-8.35-28.89-7.65-42.74-5.31A364.62,364.62,0,0,1,187.15,272c-6.37,5.46-15.56,11.3-25.6,16.28l-6.32,36.29c40.91-9.47,80.22-39.36,107.23-75.2C261.9,248.87,261.32,248.37,260.7,247.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264.71,166c-3.48,17.24-15.64,39.77-35.4,63.63,13.31-.72,27.75,1,38.36,9,.54.4,1.05.83,1.56,1.26,17.94-26.61,28.94-55.67,28.95-81.7A110.29,110.29,0,0,0,264.71,166Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitelogo);
export default __webpack_public_path__ + "static/media/whitelogo.697fb218bd01bc11c80264d1b9530039.svg";
export { ForwardRef as ReactComponent };